import IconWithContainer from './IconWithContainer';

export default IconWithContainer;
